<template>
  <v-sheet class="booking-staff-selector" elevation="0">
    <div class="booking-staff-selector__header">
      <BookingStepHeader :step="step">
        <template #title>
          {{ title }}
        </template>
        <template #addon>
          <slot name="addon">
            <v-progress-circular v-if="loading" indeterminate color="primary" size="20" />
          </slot>
        </template>
      </BookingStepHeader>
    </div>

    <div v-if="!loading && !hasStaff" class="booking-staff-selector__empty">
      <slot name="empty">
        {{ emptyText }}
      </slot>
    </div>

    <div v-else class="booking-staff-selector__grid">
      <button v-for="staff in staffList" :key="staff.id" type="button" class="booking-staff-selector__card" :class="{ 'is-active': staff.id === selectedId }" @click="handleStaffClick(staff)">
        <div class="booking-staff-selector__media">
          <v-img v-if="getStaffImage(staff)" :src="getStaffImage(staff)" :lazy-src="placeholderImage" aspect-ratio="1" class="booking-staff-selector__img" />
          <div v-else class="booking-staff-selector__initial">
            {{ getStaffInitial(staff) }}
          </div>
        </div>
        <div class="booking-staff-selector__name">{{ staff.name }}</div>
      </button>
    </div>
  </v-sheet>
</template>

<script>
import BookingStepHeader from "@/views/booking/components/StepHeader"

export default {
  name: "BookingStaffSelector",
  props: {
    step: {
      type: [Number, String],
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    staffList: {
      type: Array,
      default: () => [],
    },
    selectedId: {
      type: [Number, String],
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: "",
    },
  },
  components: {
    BookingStepHeader,
  },
  computed: {
    hasStaff() {
      return Array.isArray(this.staffList) && this.staffList.length > 0
    },
    placeholderImage() {
      return require("@/assets/placeholder.jpg")
    },
  },
  methods: {
    handleStaffClick(staff) {
      if (!staff || this.loading) {
        return
      }
      this.$emit("click", staff)
    },
    getStaffInitial(staff) {
      if (!staff || !staff.name) {
        return ""
      }
      return staff.name.trim().charAt(0).toUpperCase()
    },
    getStaffImage(staff) {
      if (!staff || !staff.profile_image || staff.profile_image.includes("user/profile_image/default.png")) {
        return null
      }
      return `/upload/user/profile_image/${staff.profile_image}`
    },
  },
}
</script>

<style scoped>
.booking-staff-selector {
  background-color: #ffefef;
  border-radius: 8px;
  padding: 16px 8px 16px;
}

.booking-staff-selector__header {
  margin-bottom: 18px;
}

.booking-staff-selector__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.booking-staff-selector__card {
  background-color: #fff;
  border: 4px solid transparent;
  border-radius: 8px;
  padding: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  row-gap: 12px;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
  text-align: center;
  width: 100%;
  outline: none;
  appearance: none;
}

.booking-staff-selector__card.is-active {
  border-color: #ff65b3;
  box-shadow: 0 6px 16px rgba(199, 114, 138, 0.24);
}

.booking-staff-selector__media {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f7f0ef;
  display: flex;
  align-items: center;
  justify-content: center;
}

.booking-staff-selector__img {
  width: 100%;
  height: 100%;
  border-radius: 16px;
}

.booking-staff-selector__initial {
  font-size: 36px;
  font-weight: 600;
  color: #ba8a94;
}

.booking-staff-selector__name {
  flex: 1;
  font-size: 16px;
  color: #5c484c;
}

.booking-staff-selector__empty {
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  color: #7a5a60;
  font-size: 14px;
  line-height: 1.6;
}

@media (max-width: 600px) {
  .booking-staff-selector__grid {
    grid-template-columns: 1fr;
  }
}
</style>
